import { Settings } from 'luxon'

const lang = document.documentElement.lang.substr(0, 2)

Settings.defaultLocale = lang.replace('_', '-')
